<template>
  <!-- Base container -->
  <div>
    <div class="filters-button" style="z-index:4">
      <base-button
        v-if="!showFilters"
        :rounded="true"
        background-color="#ea1d75"
        @click.prevent="showFilters = true"
      >
        <img style="width: 25px; margin: 0 auto;" src="../assets/icons/filterIcon.svg" alt />
      </base-button>
    </div>
    <div class="base-container" :class="showFilters ? 'filters-on' : 'filters-off'">
      <!-- Show two images to compare in the page top -->
      <div class="top-images-container" id="top-images-container">
        <top-image :product="pivot" />
        <div style="cursor: pointer; width: 30%; margin: 0 auto; min-width: 260px; height: 40px;">
          <div
            style="float:left; width: 35px; height: 35px; background-color: #ea1d75; border-radius: 50%; font-weight: 700; font-size: 30px;"
            @click.prevent="currentPage > 1 ? pagination('substract') : null"
          >-</div>
          <div style="display: inline; font-size: 30px;">
            <span>{{ currentPage }} / {{ totalPages }}</span>
          </div>
          <div
            style="float:right; width: 35px; height: 35px; background-color: #ea1d75; border-radius: 50%; font-weight: 700; font-size: 30px;"
            @click.prevent="currentPage < totalPages ? pagination('add') : null"
          >+</div>
        </div>
        <div style="margin-top: 20px;">
          <base-button
            background-color="#ea1d75"
            @click.prevent="saveMatches"
            :disabled="savingMatches"
          >Guardar Matches</base-button>
        </div>
        <div style="max-width: 300px; margin: 30px auto 20px auto">
          <input
            placeholder="Ir a página"
            v-model="goPage"
            class="input-container"
            type="number"
            id="others-ids"
          />
        </div>
        <div style="margin-top: 20px;">
          <base-button background-color="#ea1d75" @click.prevent="pagination('goToPage')">Ir</base-button>
        </div>
      </div>
      <!-- Show other images to compare -->
      <div class="images-container" id="images-container">
        <div id="images-top"></div>
        <div v-for="item in minis" :key="item.id">
          <mini-card :product="item" @matchFromBottom="setMatchFromBottom(item)" />
        </div>
      </div>
    </div>

    <!-- Show the posible filters -->
    <filter-menu
      ref="filters"
      :currentPage="currentPage"
      @closeFilters="closeFiltersTab"
      @receive-info="receiveInfo"
      :show="showFilters"
      @clearMinisFromFilters="clearMinis"
    />

    <!-- Go top button -->
    <div class="go-top-button">
      <base-button background-color="#ea1d75" @click.prevent="goTop">Go Top</base-button>
    </div>
  </div>
</template>
<script>
import FilterMenu from "../components/FilterMenu";
import MiniCard from "../components/MiniCard";
import RequestService from "@/services/RequestService.js";
import TopImage from "../components/TopImage";

export default {
  components: {
    FilterMenu,
    MiniCard,
    TopImage
  },
  data() {
    return {
      goPage: null,
      showFilters: true,
      pivot: {
        id: "",
        image:
          "https://c-lj.gnst.jp/public/img/common/noimage.jpg?20181011050048",
        name: "Sin información",
        url: "",
        seller: {
          id: "0",
          name: "Sin pivote"
        }
      },
      selectedIndex: null,
      oldIndex: null,
      anotherPivot: {},
      minis: [],
      currentPage: 0,
      totalPages: 0,
      requesting: false,
      savingMatches: false
    };
  },
  methods: {
    closeFiltersTab() {
      this.showFilters = false;
    },
    selectImage(item) {
      const currentSelected = this.minis.find(mini => mini.selected === true);
      currentSelected.selected = false;
      item.selected = true;
    },
    receiveInfo(e) {
      this.pivot = e[0];
      this.minis = e[1];
      this.currentPage = e[2];
      this.totalPages = e[3];
    },
    setMatchFromBottom(item) {
      const toUpdateMatch = this.minis.find(
        mini => mini.products[0].id === item.products[0].id
      );
      toUpdateMatch.match = !toUpdateMatch.match;
    },
    goTop() {
      document
        .querySelector("#images-top")
        .scrollIntoView({ behavior: "smooth" });
    },
    clearMinis() {
      this.minis = [];
    },
    pagination(operation) {
      this.clearMinis();
      const page =
        operation === "add"
          ? this.currentPage + 1
          : operation === "substract"
          ? this.currentPage - 1
          : this.goPage;
      this.$refs.filters.getSimilars(page);
    },
    async saveMatches() {
      this.savingMatches = true;
      const getMatchesArrays = this.minis
        .filter(mini => mini.match)
        .map(mini => mini.products);
      const pivot = {
        id: this.pivot.id,
        seller: this.pivot.seller.id
      };
      // "pivot": {"id": "09489408234", "seller": 300},
      const matches = [];
      for (let i = 0; i < getMatchesArrays.length; i++) {
        for (let j = 0; j < getMatchesArrays[i].length; j++) {
          matches.push({
            id: getMatchesArrays[i][j].id,
            seller: getMatchesArrays[i][j].seller.id
          });
        }
      }
      const data = {
        pivot,
        matches
      };
      RequestService.saveMatches(data)
        .then(response => {
          if (response && response.data === "OK") {
            this.$toasted.success("Matches guardados! vamos por ese almuerzo");
          } else {
            this.$toasted.error(
              "Ocurrio un problema al intentar guardar los matches."
            );
          }
          this.savingMatches = false;
        })
        .catch(err => {
          this.$toasted.error(
            `Ocurrio un problema al intentar guardar los matches. Error: ${err.response}`
          );
          this.savingMatches = false;
        });
    }
  }
};
</script>

<style>
.base-container {
  height: 100vh;
  overflow: scroll;
  transition: all 0.5s;
}
.filters-on {
  width: calc(100% - 300px);
}
.filters-off {
  width: 100%;
}
.go-top-button {
  position: fixed;
  bottom: 2em;
  right: 2em;
  z-index: 3;
}
.images-container {
  max-width: 70%;
  float: right;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* overflow: scroll; */
}
.top-images-container {
  width: 25%;
  max-width: 500px;
  position: absolute;
  background-color: #621f65;
  padding: 30px;
  float: left;
  justify-content: center;
  margin: 0;
  height: 100vh;
  padding: 0;
  color: #fff;
  overflow: scroll;
}

body {
  margin: 0;
  max-width: 100vw;
  min-width: 100vw;
  overflow: hidden;
}

.product-url-link {
  color: #fff;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

::-webkit-scrollbar {
  width: 10px;
  background: transparent;
}

::-webkit-scrollbar-thumb {
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale !important;
  background: #ea1d75;
  color: #fff !important;
  border-radius: 10px;
}

.filters-button {
  position: fixed;
  z-index: 1;
  top: 2em;
  right: 2em;
}

.select-css input {
  display: block;
  font-size: 16px;
  font-family: sans-serif;
  font-weight: 700;
  color: #444;
  line-height: 1.3;
  padding: 0.6em 1.4em 0.5em 0.8em;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin: 0;
  border: 1px solid #fff;
  border-radius: 0.5em;
  -moz-appearance: none;
  -webkit-appearance: none;
  background-color: #fff;
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
  outline: none;
}
</style>
